import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-hand-agreement',
  templateUrl: './fh-svg-hand-agreement.component.html',
  styleUrl: './fh-svg-hand-agreement.component.scss'
})
export class FhSvgHandAgreementComponent {
  @Input() color: string = '';
}
